module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('panel', {
    attrs: {
      "title": _vm.account.shopName
    }
  }, [_c('span', {
    class: _vm.authenticated ? 'badge badge--success' : 'badge badge--danger',
    attrs: {
      "slot": "header-right"
    },
    slot: "header-right"
  }, [_vm._v(_vm._s(_vm.authenticated ? 'Autenticado' : 'Não Autenticado'))]), _vm._v(" "), _c('loader', {
    attrs: {
      "loading": _vm.authenticating,
      "label": "Autenticando..."
    }
  }), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-12@md img-account"
  }, [(_vm.account.logo) ? _c('img', {
    attrs: {
      "src": _vm.account.logo
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.account.logo) ? _c('i', {
    staticClass: "icon-image2 no-photo"
  }) : _vm._e()]), _vm._v(" "), (_vm.blockedAccount()) ? _c('div', [_c('h5', [_c('span', {
    staticClass: "c-alert--danger"
  }, [_vm._v("Conta com recursos bloqueados")])]), _vm._v(" "), _c('p', [_vm._v("Siga o passo-a-passo abaixo")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("1")]), _vm._v(") Por favor, entre em "), _c('a', {
    attrs: {
      "href": "https://sellercentral.amazon.com.br/hz/sc/account-information",
      "alt": "Seller Central - Account Information"
    }
  }, [_vm._v("\n          Seller Central - Account Information")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("2")]), _vm._v(") Após regularizar, clique no botão abaixo")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn--smart btn--sm btn--info",
    on: {
      "click": _vm.solveAccount
    }
  }, [_vm._v("\n          Confirmar solução de pendência no Seller Central\n        ")])]) : _vm._e()])]), _vm._v(" "), _c('footer', {
    staticClass: "c-card__footer u-textLeft l-level"
  }, [_c('button', {
    staticClass: "btn btn--smart btn--sm btn--info l-level__left",
    on: {
      "click": _vm.editAction
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('edit.label')) + "\n    ")]), _vm._v(" "), _c('button', {
    staticClass: "header-right btn btn--smart btn--sm btn--danger l-level__right",
    attrs: {
      "slot": "header-actions"
    },
    on: {
      "click": function($event) {
        _vm.modalDeleteAccountFlag = true
      }
    },
    slot: "header-actions"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('delete.label')) + "\n    ")])]), _vm._v(" "), _c('modal-delete-account', {
    on: {
      "confirm": _vm.deleteAccount
    },
    model: {
      value: (_vm.modalDeleteAccountFlag),
      callback: function($$v) {
        _vm.modalDeleteAccountFlag = $$v
      },
      expression: "modalDeleteAccountFlag"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d0e17e8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/amazon/Account.vue
// module id = 2899
// module chunks = 0